import { Pipe, PipeTransform } from '@angular/core';
import { AlertType } from 'src/app/core/enums';

@Pipe({ name: 'alertThreshold' })
export class AlertThresholdPipe implements PipeTransform {

  transform(value: number, alertType: string): string {
    let returnText = value.toString();
    switch(alertType){
      case AlertType.Cost:
        returnText = `£${value}`;
        break;
      case AlertType.Data:
        returnText = `${value} MB`;
        break;
      case AlertType.CostLimit:
        returnText = `${value} %`;
        break;
    }
    return returnText;
  }
}
